
const _ = require('lodash');

const ko = require('knockout');

const $ = require('jquery');
require('rgs-bootstrap');


function bsTooltipPopoverBindingFactory (options) {
	options = _.defaults({}, options, {
		bsPluginName: 'tooltip',
	});

	function plugin ($el, ...args) {
		return $el[options.bsPluginName](...args);
	}

	return {
		init: function (element, valueAccessor) {
			function getParams () {
				const params = ko.unwrap(valueAccessor()) || {};
				return _.defaults({}, params, {
					trigger: (params.visible === undefined) ? undefined : 'manual',
				});
			}

			const $element = $(element);

			ko.computed(() => {
				const params = getParams();

				plugin($element, 'destroySync');
				plugin($element, params);

				if (params.visible !== undefined) {
					setTimeout(() => {
						// HACK: setTimeout of 0 is needed since when binding is applied
						// the `element' does not have meaningful offsetWidth/Height props
						// yet, which makes the initial tooltip placement incorrect.
						plugin($element, params.visible ? 'show' : 'hide');
					}, 0);
				}
			}, null, {
				disposeWhenNodeIsRemoved: element,
			});
		},
	};
}


// Bootstrap tooltip binding
ko.bindingHandlers.bsTooltip = bsTooltipPopoverBindingFactory({
	bsPluginName: 'tooltip',
});

module.exports = {
	bsTooltipPopoverBindingFactory,
};
